import React from 'react';
import Navbar from '../Navbar/Navbar'; // Adjust path as needed
import './HomePage.css';
import { useNavigate } from 'react-router-dom';
import Background from './alien.png';
import PdfThumbnail from '../EI/leaf.png'; // Leaf image

const HomePage = ({ isLoggedIn, onLogout }) => {
  const navigate = useNavigate();

  // Opens Dash.pptx in a new tab
  const handleOpenPpt = () => {
    window.open('/Dash.pptx', '_blank'); // Ensures it opens in a new tab
  };

  const handleImageClick = () => {
    navigate('/fuel'); // Navigate to /fuel page
  };

  return (
    <div className="home-container">
      <Navbar isLoggedIn={isLoggedIn} onLogout={onLogout} />

      <section className="hero">
        <h2>Enhance vessel performance with sustainable graphene-based marine coatings</h2>
        <p>Reduce fuel consumption and protect the environment with GIT’s biocide-free hard foul release hull and propeller coatings while decarbonizing your fleet.</p> 
      </section>

      <footer className="footer">
        <p className="footer-text">Made with dedication by the Vessel Performance Team.</p>

        <div className="footer-thumbnails">
          {/* FAQ Section - Left Side */}
          <div className="faq-container" onClick={handleOpenPpt}>
            <img src={PdfThumbnail} alt="Leaf Icon" className="leaf-thumbnail" />
            <span className="faq-text">FAQs</span>
          </div>

          {/* Right-Side Thumbnail */}
          <img src={Background} alt="Thumbnail" className="thumbnail" onClick={handleImageClick} />
        </div>
      </footer>
    </div>
  );
};

export default HomePage;
